<template>
	<div>
		<div v-show="value" class="bg">
			<div @click.stop class="cusdialog" :style="{width: width}">
				<div class="title">
					<font style="">{{title != '提示'?title:''}}</font>
					<font @click="handleClose()" style="margin-right: 20px;font-size: 22px;cursor: pointer;">×</font>
				</div>
				<div :class="(defaultFooter || this.$slots.footer) ? 'slotc_bottom':'slotc' ">
					<slot> </slot>
				</div>
				<span v-if="defaultFooter" class="dialog-footer">
					<el-row type="flex" justify="end" style="width: 100%;">
						<el-button @click="handleClose"> 取消</el-button>
						<el-button @click="btnSave" type="primary" style="margin-right: 20px;background-color: #AA1D1F;color: white;border: none;"> {{submitText}}</el-button>
					</el-row>
				</span>

				<span v-if="defaultFooter == false && this.$slots.footer">
					<slot name="footer"> </slot>
				</span>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: 'cus-dialog',
		data() {
			return {};
		},

		computed: {

		},
		watch: {

		},
		props: {
			value:{},
			title: {
				type: String,
				default: '提示'
			},
			width: {
				default: '600px'
			},
			defaultFooter: {
				default: false
			},
			submitText:{
				type: String,
				default: '确认'
			}

		},
		mounted() {
			// console.log(this.$slots)
		},
		methods: {
			handleClose() {
				this.$emit('beforeClose')
				this.$emit('input', false)
			},
			btnSave(){
				this.$emit('clickCommit')
			}

		}
	};
</script>

<style scoped>
	.bg {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 2000;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cusdialog {
		border-radius: 2px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
		box-sizing: border-box;
		background-color: white;
	}

	.slotc {
		overflow-y: auto;
		max-height: 60vh;
		padding-right: 10px;
		padding-left: 10px;
		padding-top: 10px;
	}

	.slotc_bottom{
		overflow-y: auto;
		max-height: 60vh;
		padding-right: 10px;
		padding-left: 10px;
		padding-top: 10px;
	}

	.slotmobc {
		overflow-y: auto;
		padding-right: 10px;
		padding-left: 10px;
		padding-top: 10px;
	}

	.title {
		justify-content: space-between;
		width: calc(100% - 10px);
		display: flex;
		align-items: center;
		font-size: 16px;
		margin-left: 10px;
		border-bottom: 1px solid #EBEBEB;
		height: 45px;
	}

	.dialog-footer {
		width: 100%;
		height: 80px;
		align-items: center;
		display: flex;
		justify-content: center;
	}

	@media screen and (max-width: 768px) {
		.cusdialog {
			width: 100% !important;
			height: 100% !important;
		}

		.slotc {
			overflow-y: auto;
			max-height: calc(100vh - 45px);
			padding-right: 10px;
			padding-left: 10px;
			padding-top: 10px;
		}
		.slotc_bottom{
			overflow-y: auto;
			padding-right: 10px;
			padding-left: 10px;
			padding-top: 10px;
			max-height: calc(100vh - 45px - 80px) !important;
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/cus-dialog.vue